import { ThirdPartyReports } from 'QuoteApp/services/endpoints/GetDetails';

export enum ReportStatus {
  Pending = 'pending',
  Error = 'error',
  Completed = 'completed',
  Ready = 'ready',
  Disabled = 'disabled',
}

// These are used mainly for test-ids
export type ReportType =
  | 'ncf-cc'
  | 'ncf'
  | 'clue-mvr'
  | 'clue'
  | 'driver-discovery';

export const reportTypeToId: { [key: string]: ReportType } = {
  [ThirdPartyReports.DriverDiscovery]: 'driver-discovery',
  [ThirdPartyReports.Ncf]: 'ncf',
  [ThirdPartyReports.NcfAndCurrentCarrier]: 'ncf-cc',
  [ThirdPartyReports.Clue]: 'clue',
  [ThirdPartyReports.All]: 'clue-mvr',
};
export type ReportInProgressType = ThirdPartyReports | null;
